<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Cyle Tramel is a seasoned traveler with a passion for cultural exploration and storytelling. He believes that everyone has a story to tell and that every story, no matter how unbelievable, deserves to be told. This is his first book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0dff4a5f